module.exports = "<!--<section class=\"announcement\">\n  <img src=\"assets/images/announcement.png\" class=\"img-fluid\" alt=\"\">\n</section>-->"